import { googleLogout } from '@react-oauth/google';
import axiosClient, { HOST } from './axiosClient';
import { INTERNAL_ADMIN_INFO } from '../constants/constants';
import { uploadData } from '../components/familytree/scripts/aws-s3';
// import messageConstant from '../constants/message.constants';

// let count = 0;
const authServices = {
  getUserIcon: async (url, userId, callback) => {
    try {
      const res = await fetch(url);
      // debug-console.log('res=', res);
      const imageBlob = await res.blob();
      // const imageObjectURL = URL.createObjectURL(imageBlob);
      // when file not exist, response will have Text/HTML blob type
      if (imageBlob.type !== 'text/html') {
        uploadData(imageBlob, userId, callback);
      } else {
        console.log('Skip uploading because of failed fetch');
      }
    } catch (err) {
      // debug-console.error('fetch Image error:', err);
    }
  },
  // axiosClient.get(url).then((res) => {
  //   console.log('get UserIcon: ', res);
  //   uploadData(res.data, userId, callback)
  //   return res;
  // })
  // .catch((error) => {
  //   console.log('getUser Icon error', error);
  //   // if (error.response) {
  //   //   return Promise.reject(error.response);
  //   // }
  //   // return Promise.reject(error);
  // }),
  // login: async ({ username, pazzword }) => {
  login: async () => INTERNAL_ADMIN_INFO,
  // axiosClient
  //   .post(`${HOST.USER_SERVICE}/authorizer/login`, {
  //     username: username.trim(),
  //     pazzword,
  //   })
  //   .then((data) => Promise.resolve(data))
  //   .catch((error) => Promise.reject(error)),
  logout: async () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (userInfo) {
      if (userInfo.userType === 'GG_USER') {
        googleLogout();
        localStorage.clear();
        window.location.href = '/admin/login';
      } else if (userInfo.userType === 'INTERNAL_USER') {
        axiosClient
          .post(`${HOST.USER_SERVICE}/authorizer/logout`)
          .then((data) => {
            localStorage.clear();
            window.location.href = '/admin/login';
            return Promise.resolve(data);
          })
          .catch((error) => {
            localStorage.clear();
            window.location.href = '/admin/login';
            return Promise.reject(error);
          });
      }
    } else {
      localStorage.clear();
      window.location.href = '/admin/login';
    }
  },
  directLogout: () => {
    localStorage.clear();
    window.location.href = '/admin/login';
  },
};

export default authServices;
